import React from "react";
import { View } from "react-native";
import { Heading, Text } from "@clearabee/ui-library-native";
import { LinearGradient } from "expo-linear-gradient";
import { verticalStyles as styles } from "./Train.styles";
import { getGradientColors, useTrainContext } from "./Train.utils";
import { TrainItemIcon } from "./TrainItemIcon";
import type { TrainItemProps } from "./Train.types";

export const TrainItemVertical = ({
  icon,
  title,
  description,
}: TrainItemProps): React.ReactElement => {
  const {
    titleSize,
    position: { current, next },
  } = useTrainContext();

  return (
    <View style={styles.wrapper}>
      <View>
        <TrainItemIcon icon={icon} />
        {!current.last && (
          <View style={styles.innerWrapper}>
            <View style={styles.lineWrapper}>
              <LinearGradient
                colors={getGradientColors(
                  current.active,
                  current.complete,
                  next.active,
                )}
                start={{ x: 1, y: 0 }}
                end={{ x: 0, y: 1 }}
                style={{ flex: 1, width: 5 }}
              />
            </View>
          </View>
        )}
      </View>

      <View style={styles.contentWrapper}>
        <Heading fontSize={titleSize} level={5}>
          {title}
        </Heading>
        {description && (
          <Text fontSize="small" styles={styles.description}>
            {description}
          </Text>
        )}
      </View>
    </View>
  );
};
